import * as Sentry from '@sentry/react';
import { AUTHENTICATION_SCOPES } from '@playbookux/playbook-web-core';

import { config } from '../../config';

import {
  AUTHENTICATION_CHANGE_COMPANY,
  AUTHENTICATION_COMPLETED,
  AUTHENTICATION_CREATE_COMPANY,
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_GET_COMPANIES_COMPLETED,
  AUTHENTICATION_GET_PROFILE_COMPLETED,
  AUTHENTICATION_INITIALIZED,
  AUTHENTICATION_LINKED_IN_STATE,
  AUTHENTICATION_REFERRAL,
  AUTHENTICATION_SIGN_IN_WITH_LINKED_IN_COMPLETED,
  AUTHENTICATION_SIGN_IN_SSO_COMPLETED,
  AUTHENTICATION_SIGN_IN_WORKOS_COMPLETED,
  AUTHENTICATION_SIGN_IN_WITH_PASSWORD_COMPLETED,
  AUTHENTICATION_SIGN_OUT,
  AUTHENTICATION_SIGN_IN_WITH_SHARED_CODE,
  AUTHENTICATION_SIGN_IN_TESTER,
  AUTHENTICATION_SCHEDULE,
  AUTHENTICATION_USER_STATUS,
  SET_USER,
  AUTHENTICATION_SIGN_IN_WITH_LIVESTREAM,
  AUTHENTICATION_MODERATED_MEETING,
} from '../actions';

const initialState = {
  intercomUserHash: null,
  isAuthenticated: false,
  isAuthenticating: false,
  linkedIn: { state: null },
  profile: null,
  referral: null,
  token: null,
  scope: null,
  isRecruitUser: false,
  company: {},
};

const authentication = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case AUTHENTICATION_LINKED_IN_STATE:
      return {
        ...state,
        linkedIn: {
          state: action.payload.state,
        },
      };

    case AUTHENTICATION_REFERRAL:
      return {
        ...state,
        referral: action.payload.referral,
      };

    case AUTHENTICATION_INITIALIZED:
      return {
        ...state,
        isAuthenticating: true,
      };

    case AUTHENTICATION_SIGN_IN_WITH_LINKED_IN_COMPLETED:
      return {
        ...state,
        intercomUserHash: action.payload.intercomUserHash,
        linkedIn: { state: null },
        referral: null,
        token: action.payload.token,
        scope: config.REACT_APP_PLATFORM_TYPE === 'tester' ? AUTHENTICATION_SCOPES.TESTER : AUTHENTICATION_SCOPES.USER,
      };

    case AUTHENTICATION_SIGN_IN_SSO_COMPLETED:
      return {
        ...state,
        intercomUserHash: action.payload.intercomUserHash,
        token: action.payload.token,
        scope: AUTHENTICATION_SCOPES.TESTER,
      };

    case AUTHENTICATION_SIGN_IN_WORKOS_COMPLETED:
      return {
        ...state,
        intercomUserHash: action.payload.intercomUserHash,
        token: action.payload.token,
        scope: AUTHENTICATION_SCOPES.USER,
      };

    case AUTHENTICATION_SIGN_IN_WITH_SHARED_CODE:
      return {
        ...state,
        token: action.payload.token,
        scope: action.payload.scope,
      };

    case AUTHENTICATION_SIGN_IN_WITH_LIVESTREAM:
      return {
        ...state,
        token: action.payload.token,
        scope: action.payload.scope,
      };

    case AUTHENTICATION_SIGN_IN_WITH_PASSWORD_COMPLETED:
      return {
        ...state,
        intercomUserHash: action.payload.intercomUserHash,
        token: action.payload.token,
        scope: AUTHENTICATION_SCOPES.USER,
      };

    case AUTHENTICATION_GET_PROFILE_COMPLETED:
      // SessionStack
      // eslint-disable-next-line no-undef
      if (window.SessionStack) {
        window.SessionStack.identify({
          userId: action.payload?.profile?.id, // Required but user might not have profile
          displayName: `${action.payload?.profile?.first_name} ${action.payload?.profile?.last_name}`, // Not required
          // Add your own custom user variables here.
        });
      }
      return {
        ...state,
        profile: action.payload?.profile,
        user: action.payload?.profile?.user,
      };

    case AUTHENTICATION_CREATE_COMPANY: {
      const { company } = action.payload;

      return {
        ...state,
        company,
      };
    }

    case AUTHENTICATION_GET_COMPANIES_COMPLETED: {
      const { company } = action.payload;

      return {
        ...state,
        company,
      };
    }

    case AUTHENTICATION_CHANGE_COMPANY: {
      const { company } = action.payload;

      return {
        ...state,
        company,
      };
    }

    case AUTHENTICATION_COMPLETED:
      return {
        ...state,
        isAuthenticated: true,
      };

    case AUTHENTICATION_SIGN_IN_TESTER: {
      const { accessToken, sessionId, isRecruitUser } = action.payload;

      return {
        ...state,
        sessionId,
        token: accessToken,
        isAuthenticated: true,
        scope: AUTHENTICATION_SCOPES.TESTER,
        isRecruitUser,
      };
    }

    case AUTHENTICATION_SCHEDULE: {
      const { token } = action.payload;

      return {
        ...state,
        token,
        isAuthenticated: true,
        scope: AUTHENTICATION_SCOPES.PUBLIC,
      };
    }

    case AUTHENTICATION_MODERATED_MEETING: {
      const { token } = action.payload;

      return {
        ...state,
        token,
        isAuthenticated: true,
        scope: AUTHENTICATION_SCOPES.PUBLIC,
      };
    }

    case AUTHENTICATION_FAILURE:
    case AUTHENTICATION_SIGN_OUT: {
      const { state: linkedInState } = state.linkedIn;

      return {
        ...initialState,
        linkedIn: {
          state: linkedInState,
        },
      };
    }
    // this is only begin used for menu header on tester module.
    case AUTHENTICATION_USER_STATUS: {
      return {
        ...state,
        status: action.payload.status,
      };
    }

    case SET_USER: {
      return {
        ...state,
        user: action.payload.user,
      };
    }
    default:
      return state;
  }
};

export default authentication;
